var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-input',{staticClass:"w-full",attrs:{"label-placeholder":"绑卡后赠金 (元)"},model:{value:(_vm.dataLocal.count),callback:function ($$v) {_vm.$set(_vm.dataLocal, "count", $$v)},expression:"dataLocal.count"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }